import {
    SET_INFO, SET_AUTH
} from "../actions.type";

const state = {
    user: {},
    isAuthenticated: false,
};
  
const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    }
};

const actions = {
    [SET_AUTH](context, info) {
        context.commit(SET_AUTH, info);
    },
};
  
const mutations = {
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js